module.exports = __webpack_public_path__ + "img/filter-by-abnormal.8b21b4f8.png";